
<template>
  <div id="conent">
    <div class="page_container">
      <div class="msg_nav">
        <h1 class="title">{{ category }}</h1>
        <div>
          <img
            src="../assets/join_member_header.png"
            alt=""
            class="inset_img"
          />
        </div>
      </div>

      <!-- loading 状态 -->
      <div v-if="loading" class="loading-overlay">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>

      <div style="height: 200px;"></div>
      <div class="mslx">
        <div class="mslx_title">市台协秘书处联系方式</div>
        <div class="contact_info">
          <div class="contact_item">
            <img src="../assets/phone_icon.png" alt="电话" />
            <div class="text">电话</div>
            <div class="sub_text" style="margin-left: 40px;">83837473 / 83878469 / 83837457</div>
          </div>
          <div class="contact_item">
            <img src="../assets/email_icon.png" alt="邮箱" />
            <div class="text">邮箱</div>
            <div class="sub_text">gztx2019@126.com</div>
          </div>
          <div class="contact_item">
            <img src="../assets/fax_icon.png" alt="传真" />
            <div class="text">传真</div>
            <div class="sub_text">83837476</div>
          </div>
          <div class="contact_item">
            <img src="../assets/address_icon.png" alt="地址" />
            <div class="text">地址</div>
            <div class="sub_text" style="margin-top: -4px;">广州市越秀区建设大马路8号逸雅居之三413室</div>
          </div>
        </div>
      </div>
      
      <div style="height: 30px;"></div>
      <div class="fhlx">
        <p class="fhlx_title">如需加入广州台协，可直接与本人所在区的分会联系。</p>
        <div style="height: 40px;"></div>
        <div>
          <div class="fhlx_item">
            <div class="fhlx_item_left">
              <div class="blue_span"></div>
              <div class="fhlx_item_title">黄埔区开发区分会</div>
              <div class="fhlx_item_phone">
                <p><b>电话：</b>13672478625（张小姐）</p>
              </div>
              <div class="fhlx_item_address">
                <p><b>地址：</b>广州市黄埔区大沙街姬堂村万达路71＃</p>
              </div>
            </div>
            <div class="fhlx_item_right">
              <div class="blue_span"></div>
              <div class="fhlx_item_title">番禺分会</div>
              <div class="fhlx_item_phone">
                <p><b>电话：</b>15814890208（黄小姐）</p>
              </div>
              <div class="fhlx_item_address">
                <p><b>地址：</b>番禺区清河东路319号</p>
              </div>
            </div>
          </div>
          <div class="fhlx_item">
            <div class="fhlx_item_left">
              <div class="blue_span"></div>
              <div class="fhlx_item_title">越秀分会</div>
              <div class="fhlx_item_phone">
                <p><b>电话：</b>18520088228（宋小姐）</p>
              </div>
              <div class="fhlx_item_address">
                <p><b>地址：</b>广州市越秀区淘金路54号世贸花园24楼C座</p>
              </div>
            </div>
            <div class="fhlx_item_right">
              <div class="blue_span"></div>
              <div class="fhlx_item_title">南沙分会</div>
              <div class="fhlx_item_phone">
                <p><b>电话：</b>18826263080（谭小姐）</p>
              </div>
              <div class="fhlx_item_address">
                <p><b>地址：</b>广州市南沙开发区凤凰大道1号行政中心D栋8楼</p>
              </div>
            </div>
          </div>
          <div class="fhlx_item">
            <div class="fhlx_item_left">
              <div class="blue_span"></div>
              <div class="fhlx_item_title">海珠分会</div>
              <div class="fhlx_item_phone">
                <p><b>电话：</b>13650980913（杨小姐）</p>
              </div>
              <div class="fhlx_item_address">
                <p><b>地址：</b>广州市荔湾区康王中路300号蓝港国际珠宝交易中心3楼3001～3009档</p>
              </div>
            </div>
            <div class="fhlx_item_right">
              <div class="blue_span"></div>
              <div class="fhlx_item_title">从化分会</div>
              <div class="fhlx_item_phone">
                <p><b>电话：</b>18826263080（谭小姐）</p>
              </div>
              <div class="fhlx_item_address">
                <p><b>地址：</b>广州市南沙开发区凤凰大道1号行政中心D栋8楼</p>
              </div>
            </div>
          </div>
          <div class="fhlx_item">
            <div class="fhlx_item_left">
              <div class="blue_span"></div>
              <div class="fhlx_item_title">荔湾分会</div>
              <div class="fhlx_item_phone">
                <p><b>电话：</b>13650980913（杨小姐）</p>
              </div>
              <div class="fhlx_item_address">
                <p><b>地址：</b>广州市增城区荔乡路91号1002台商协会</p>
              </div>
            </div>
            <div class="fhlx_item_right">
              <div class="blue_span"></div>
              <div class="fhlx_item_title">增城分会</div>
              <div class="fhlx_item_phone">
                <p><b>电话：</b>13202526686（刘先生）</p>
              </div>
              <div class="fhlx_item_address">
                <p><b>地址：</b>广州市增城区荔乡路91号1002台商协会</p>
              </div>
            </div>
          </div>
          <div class="fhlx_item">
            <div class="fhlx_item_left">
              <div class="blue_span"></div>
              <div class="fhlx_item_title">天河分会</div>
              <div class="fhlx_item_phone">
                <p><b>电话：</b>38622237(陈先生) </p>
              </div>
              <div class="fhlx_item_address">
                <p><b>地址：</b>广州市天河区天府路天府路1号</p>
              </div>
            </div>
            <div class="fhlx_item_right">
              <div class="blue_span"></div>
              <div class="fhlx_item_title">花都分会</div>
              <div class="fhlx_item_phone">
                <p><b>电话：</b>13926229890（林小姐） </p>
              </div>
              <div class="fhlx_item_address">
                <p><b>地址：</b>花都区公益路35号民政大楼二楼</p>
              </div>
            </div>
          </div>
          <div class="fhlx_item">
            <div class="fhlx_item_left">
              <div class="blue_span"></div>
              <div class="fhlx_item_title">白云分会</div>
              <div class="fhlx_item_phone">
                <p><b>电话：</b>13710670044（张小姐）</p>
              </div>
              <div class="fhlx_item_address">
                <p><b>地址：</b>白云区鹤龙街鹤龙一路88号汇龙海峡两岸青年创业基地B座304之三</p>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div style="clear: both"></div>
      <CopyrightLayout></CopyrightLayout>
    </div>
  </div>
</template>

<script>
import CopyrightLayout from '@/layout/CopyrightLayout.vue';
export default {
  name: "JoinMember",
  components:{CopyrightLayout},
  data() {
    return {
      category: "联系方式",
      loading: false // 添加 loading 状态
    };
  },
  methods: {
  },
  mounted() {
    
  },
};
</script>

<style scoped>
@import "../style/common.css";
@import "../style/message-list.css";
@import "../style/loading.css";
.mslx{
  width: 1200px;
  height: 300px;
  margin:0 auto;
  background: white;
  border-radius: 20px;
  /* 卡片蓝色外阴影 */
  box-shadow: 0px 4px 40px 0px rgba(50, 132, 255, 0.1);

}
.mslx_title{
  font-family: MiSans;
  font-size: 24px;
  font-weight: 500;
  color: #1A1A1A;
  width: 980px;
  padding-left: 30px;
  padding-top: 40px;
}
.contact_item{
  margin-top: 38px;
  width: 280px;
  height: 150px;
  float: left;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
}
.text,.sub_text{
  width: 280px;
  text-align: center;
}
.sub_text{
  font-family: MiSans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3D3D3D;
}

.fhlx{
  width: 1200px;
  height: 1070px;
  border-radius: 20px;
  margin: 0 auto;
  background: #FFFFFF;
  box-shadow: 0px 4px 40px 0px rgba(50, 132, 255, 0.1);
}
.fhlx_title{
  padding-left: 30px;
  padding-top: 40px;
  width: 980px;
  height: 30px;
  font-family: MiSans;
  font-size: 22px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  /* 纯黑 */
  color: #000000;
}
.fhlx_item{
  clear: both;
}
.fhlx_item_left,.fhlx_item_right{
  width: 570px;
  height: 130px;
  float: left;
  margin-top: 20px;
}
.blue_span{
  float: left;
  margin-top: 3px;
  margin-left:30px;
  width: 4px;
  height: 20px;
  /* 主题色 */
  background: #3284FF;
}
.fhlx_item_title{
  float: left;
  margin-left: 16px;
  font-size: 20px;
  font-weight: 500; 
  color: #1A1A1A;
}
.fhlx_item_phone,.fhlx_item_address{
  display: block;
  clear: both;
  width: 500px;
  margin-left: 50px;
  font-family: MiSans;
  font-size: 16px;
  font-weight: normal;
  padding-top:15px;
}
</style>